module.exports = __webpack_public_path__ + "img/telegram.4f7b6681.svg";